"use strict";

{
  const KASOU_LP_VALUES = ["kasou01", "kasou02"];
  const SOUGI_LP_VALUES = ["sougi01", "sougi02"];
  const UTM_LP_DATA_ATTR_VALUES = [...KASOU_LP_VALUES, ...SOUGI_LP_VALUES];

  /**
   * data-utm-lp と、各 LP の .p-cta__lpDefault / .p-cta__lpAb の表示切り替え。
   * コンテナ ID: 火葬 A/B … kasouFvCta、葬儀 A/B … sougiFvCta（該当ページにのみ存在）。
   */
  function applyLpAbCtaVariants() {
    const params = new URLSearchParams(window.location.search);
    const utmLp = params.get("utm_lp");
    if (utmLp !== null && UTM_LP_DATA_ATTR_VALUES.includes(utmLp)) {
      document.documentElement.setAttribute("data-utm-lp", utmLp);
    } else {
      document.documentElement.removeAttribute("data-utm-lp");
    }

    function toggle(containerId, lpValues) {
      const container = document.getElementById(containerId);
      if (!container) {
        return;
      }
      const isLpAb = utmLp !== null && lpValues.includes(utmLp);
      const lpDefault = container.querySelector(".p-cta__lpDefault");
      const lpAb = container.querySelector(".p-cta__lpAb");
      if (lpDefault) {
        lpDefault.hidden = isLpAb;
      }
      if (lpAb) {
        lpAb.hidden = !isLpAb;
      }
    }

    toggle("kasouFvCta", KASOU_LP_VALUES);
    toggle("sougiFvCta", SOUGI_LP_VALUES);
  }

  applyLpAbCtaVariants();

  /**
   * kasou-a / kasou-b の FV背景のみ差し替え（?utm_mv=キー）。
   * キーと画像パスを追加するたびにここに1行足す（任意の値は無視＝既存デザインのまま）。
   */
  const UTM_MV_MAP = {
    // 例: campaign01: "assets/img/kasou-fv_campaign01.webp",
  };

  function applyKasouMvVariant() {
    const fv = document.querySelector(".l-kasou__fv.-kasouFV--a.p-fv");
    if (!fv) {
      return;
    }
    const params = new URLSearchParams(window.location.search);
    const key = params.get("utm_mv");
    document.documentElement.removeAttribute("data-utm-mv");
    document.documentElement.style.removeProperty("--kasou-fv-bg2");
    if (!key || !Object.prototype.hasOwnProperty.call(UTM_MV_MAP, key)) {
      return;
    }
    const path = UTM_MV_MAP[key];
    if (typeof path !== "string" || !path.trim()) {
      return;
    }
    const safePath = path.trim();
    document.documentElement.style.setProperty("--kasou-fv-bg2", `url("${safePath}")`);
    document.documentElement.setAttribute("data-utm-mv", key);
  }

  applyKasouMvVariant();

  const COOKIE_DIRECTION_ONLY = "direction_only";
  const COOKIE_ALREADY_BOOKED = "already_booked";
  const COOKIE_EXPIRE_DAYS = 365;

  function setCookie(name, value, days) {
    const expires = new Date(Date.now() + days * 864e5).toUTCString();
    document.cookie = `${name}=${encodeURIComponent(
      value
    )}; expires=${expires}; path=/; SameSite=Lax`;
  }

  function deleteCookie(name) {
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; SameSite=Lax`;
  }

  function getCookie(name) {
    const row = document.cookie.split("; ").find((r) => r.startsWith(`${name}=`));
    if (!row) {
      return null;
    }
    return decodeURIComponent(row.slice(name.length + 1));
  }

  function openModalById(id) {
    const dialog = document.getElementById(id);
    if (!dialog) {
      return false;
    }
    if (!dialog.open) {
      dialog.showModal();
      dialog.classList.add("js-show");
    }
    return true;
  }

  const modal1OpenBtn = document.querySelector('[data-dialog="modal1"]');
  if (modal1OpenBtn) {
    modal1OpenBtn.addEventListener("click", () => {
      deleteCookie(COOKIE_ALREADY_BOOKED);
      setCookie(COOKIE_DIRECTION_ONLY, "1", COOKIE_EXPIRE_DAYS);
    });
  }

  const modal2OpenBtn = document.querySelector('[data-dialog="modal2"]');
  if (modal2OpenBtn) {
    modal2OpenBtn.addEventListener("click", () => {
      deleteCookie(COOKIE_DIRECTION_ONLY);
      setCookie(COOKIE_ALREADY_BOOKED, "1", COOKIE_EXPIRE_DAYS);
    });
  }

  const telLinks = document.querySelectorAll('a[href^="tel:"]');
  telLinks.forEach((link) => {
    link.addEventListener("click", (e) => {
      if (link.closest("#modalHallSelect") || link.closest("dialog")) {
        return;
      }
      let targetId = null;
      if (getCookie(COOKIE_ALREADY_BOOKED) === "1") {
        targetId = "modal2";
      } else if (getCookie(COOKIE_DIRECTION_ONLY) === "1") {
        targetId = "modal1";
      }
      if (!targetId) {
        return;
      }
      const dialog = document.getElementById(targetId);
      if (!dialog) {
        return;
      }
      e.preventDefault();
      openModalById(targetId);
    });
  });
}
